module.exports = __webpack_public_path__ + "static/service-3-0d9594d05472bcf82a52a11078a30766.jpg";